import React from 'react';
import { drawDesertEnvironment } from '@/utils/sandyDunes/desertEnvironment.js';

export function SandyDunes({ ctx, dataArray, width, height, isPlaying }) {
  const time = Date.now() * 0.001; // Convert to seconds for smooth animation
  drawDesertEnvironment(ctx, dataArray, width, height, time);
}